<div
  *ngIf="isVisible"
  class="container"
  #draggablePreview
  [style.transform]="sanitizeStyle()"
>
  <header>
    <div
      class="topHeader"
      [ngClass]="{ active: isDragged }"
      (mousedown)="onMouseDown($event)"
      (mouseup)="onMouseUp($event)"
      (mousemove)="onMouseMove($event)"
    >
      MEDIA PREVIEW
      <div class="icons">
        <div
          class="close"
          inlineSVG="/assets/icons/x-close-pop.svg"
          (click)="close()"
        ></div>
      </div>
    </div>
  </header>
  <section *ngIf="isVisible" #fullscreenContainer class="fullscreen-container">
    <video-container
      [posterUrl]="snapshot"
      [videoUrl]="videoUrl"
      [startTime]="startTime"
      [autoPlay]="autoPlay"
      [framerate]="framerate"
      [showTimecode]="showTimecode"
    ></video-container>
  </section>
</div>
